const differenceDatesInSeconds = (d1, d2) =>
	Math.abs(Math.round((d2.getTime() - d1.getTime()) / 1000))

export default differenceDatesInSeconds